export const BU_TAG_COLORS = [
  'white',
  'light',
  'dark',
  'black',
  'text',
  'primary',
  'link',
  'info',
  'success',
  'warning',
  'danger'
];

export const BU_TAG_SIZES = [
  'small',
  'medium',
  'large'
];
